import { ComponentProvider, MessageList, MessageSimple, useChannelActionContext } from 'stream-chat-react';
import type { MessageUIComponentProps } from 'stream-chat-react';
import type { LocalMessage } from 'stream-chat';
import { Spinner } from '@ds';
import { customRenderMessagesWithClick } from './ChatContent/Messages/customRenderMessagesWithClick';
import { CHAT_LABEL_NO_PINNED_MESSAGES } from '../constants';

export type PinnedMessagesPanelProps = {
  pinnedMessages: LocalMessage[];
  chatName: string;
  loading: boolean;
  onClose: () => void;
};

const MessageNoHover = (props: MessageUIComponentProps) => {
  return <MessageSimple {...props} threadList />;
};

export const PinnedMessagesPanel = ({ pinnedMessages, chatName, loading, onClose }: PinnedMessagesPanelProps) => {
  const { jumpToMessage } = useChannelActionContext();

  let content;
  if (loading) {
    content = <Spinner />;
  } else if (pinnedMessages.length === 0) {
    content = <p className="text-gray-500 text-center">{CHAT_LABEL_NO_PINNED_MESSAGES(chatName)}</p>;
  } else {
    content = (
      <ComponentProvider
        value={{
          Message: MessageNoHover,
        }}
      >
        <MessageList
          messages={pinnedMessages}
          onlySenderCanEdit={false}
          renderMessages={customRenderMessagesWithClick((message) => {
            if (message.id) {
              jumpToMessage(message.id);
              onClose();
            }
          })}
          messageActions={[]}
          disableQuotedMessages
          threadList
          closeReactionSelectorOnClick
        />
      </ComponentProvider>
    );
  }

  return <div className="pinned-messages-panel">{content}</div>;
};
